module.exports = __webpack_public_path__ + "media/images/bsmart/icons/da_svolgere_allenamento_facilitato-16e2385ceb042b838b3f428093de6f81.svg";